import React from 'react';
import { CircularProgress } from 'material-ui/Progress';

export default () => <div className="loader" >
<CircularProgress color="accent" size={100}/>
</div>;


// WEBPACK FOOTER //
// ./src/commons/ui/components/LoadingIndicator.js